//Dependencies
import React from 'react';

/* NAVBAR */
const Navbar01 = (props) =>
{  
  const { title, height, visible } = props; 
  if(!visible) return null;

  return(
    <nav 
      className = {`fixed top-0 flex justify-center items-center bg-white	text-gray-800 w-screen shadow-xl z-[1000]`}
      style = {{height : height}}
    >
      <h1 
        className = "xl:text-4xl text-2xl font-bold font-heading tracking-wider m-0" 
      >
        {title.toUpperCase()}
      </h1>
    </nav>
  );
}

export default Navbar01;